// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as MapUtils from "../../../../order-dashboard/view/library/map/map-mods-tbd-catalyst/utils/MapUtils.bs.js";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as GoogleMapHelper from "../../../../order-dashboard/view/library/map/views/GoogleMapHelper.bs.js";
import * as GoogleMarkerComponent from "../../../../order-dashboard/view/library/map/map-mods-tbd-catalyst/google/views/GoogleMarkerComponent.bs.js";
import * as Api from "@react-google-maps/api";

function PlaceOrderMapCmp(Props) {
  var pickupLatLng = Props.pickupLatLng;
  var dropLatLng = Props.dropLatLng;
  var defaultLatLng = Props.defaultLatLng;
  var wayPointOneLatLng = Props.wayPointOneLatLng;
  var wayPointTwoLatLng = Props.wayPointTwoLatLng;
  var wayPointThreeLatLng = Props.wayPointThreeLatLng;
  var match = React.useState(function () {
        
      });
  var setMap = match[1];
  var map = match[0];
  var getEnabledLocations = function (param) {
    return Belt_List.toArray(Belt_List.keepMap({
                    hd: pickupLatLng,
                    tl: {
                      hd: wayPointOneLatLng,
                      tl: {
                        hd: wayPointTwoLatLng,
                        tl: {
                          hd: wayPointThreeLatLng,
                          tl: {
                            hd: dropLatLng,
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }, (function (x) {
                      return x;
                    })));
  };
  React.useEffect((function () {
          var locationList = getEnabledLocations(undefined);
          if (map !== undefined) {
            var currentMap = Caml_option.valFromOption(map);
            var bounds = new (window.google.maps.LatLngBounds)(undefined);
            locationList.forEach(function (e) {
                  var newBound = bounds.extend(e);
                  currentMap.fitBounds(newBound);
                  
                });
          }
          
        }), [
        pickupLatLng,
        wayPointOneLatLng,
        wayPointTwoLatLng,
        wayPointThreeLatLng,
        dropLatLng
      ]);
  var getMarkerCmp = function ($$location, map, locationType) {
    if ($$location === undefined) {
      return null;
    }
    var tmp;
    switch (locationType) {
      case /* PickUp */0 :
          tmp = {
            TAG: /* Elem */1,
            _0: React.createElement(MapUtils.PickUpIcon.make, {
                  label: "P"
                })
          };
          break;
      case /* Drop */1 :
          tmp = {
            TAG: /* Elem */1,
            _0: React.createElement(MapUtils.DropIcon.make, {
                  label: "D"
                })
          };
          break;
      case /* WayPointOne */2 :
          tmp = {
            TAG: /* Elem */1,
            _0: React.createElement(MapUtils.WayPointIcon.make, {
                  label: 0
                })
          };
          break;
      case /* WayPointTwo */3 :
          tmp = {
            TAG: /* Elem */1,
            _0: React.createElement(MapUtils.WayPointIcon.make, {
                  label: 1
                })
          };
          break;
      case /* WayPointThree */4 :
          tmp = {
            TAG: /* Elem */1,
            _0: React.createElement(MapUtils.WayPointIcon.make, {
                  label: 2
                })
          };
          break;
      
    }
    return React.createElement(React.Fragment, undefined, React.createElement(GoogleMarkerComponent.make, {
                    mapInst: map,
                    markerData: {
                      location: $$location,
                      icon_data: tmp,
                      tooltip: {
                        title: "Pickup Locarion",
                        ts: undefined,
                        address: undefined
                      }
                    },
                    basePosition: $$location,
                    markerAnchor: {
                      iconAnchor: [
                        0,
                        0
                      ],
                      popupAnchor: [
                        0,
                        0
                      ]
                    },
                    uid: 0,
                    showPopup: false,
                    togglePopupVisibility: (function (param) {
                        
                      }),
                    key: "vehicle-marker"
                  }));
  };
  var getPolyline = function (param) {
    var locationList = getEnabledLocations(undefined);
    return GoogleMapHelper.getBilledPolylineComp(locationList);
  };
  var tmp;
  if (map !== undefined) {
    var map$1 = Caml_option.valFromOption(map);
    tmp = React.createElement(React.Fragment, undefined, getMarkerCmp(pickupLatLng, map$1, /* PickUp */0), getMarkerCmp(wayPointOneLatLng, map$1, /* WayPointOne */2), getMarkerCmp(wayPointTwoLatLng, map$1, /* WayPointTwo */3), getMarkerCmp(wayPointThreeLatLng, map$1, /* WayPointThree */4), getMarkerCmp(dropLatLng, map$1, /* Drop */1), getPolyline(undefined));
  } else {
    tmp = null;
  }
  return React.createElement(Api.GoogleMap, {
              center: pickupLatLng !== undefined ? pickupLatLng : (
                  dropLatLng !== undefined ? dropLatLng : defaultLatLng
                ),
              zoom: 2000,
              id: "place-order-map",
              mapContainerClassName: "map-with-tracker",
              clickableIcons: undefined,
              onLoad: (function (value) {
                  return Curry._1(setMap, (function (param) {
                                return Caml_option.some(value);
                              }));
                }),
              onTilesLoaded: undefined,
              options: undefined,
              ref: undefined,
              children: tmp
            });
}

var make = PlaceOrderMapCmp;

export {
  make ,
  
}
/* react Not a pure module */
